

























































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { QInput } from 'quasar'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import api from 'src/assets/api/gql'
import ContactUpdate from 'src/graphql/contact/ContactUpdate.gql'
import { Contact, ContactPatch, ContactGroup } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen,
    PersonAvatar
  }
})
export default class ContactEditor extends Vue {
  loading = false
  error = false
  name = ''
  contact: Contact = { contactGroups: [], contactPersonPublicProfile: {} } as unknown as Contact

  @Prop()
  readonly groups!: ContactGroup[]

  @Ref()
  readonly dialog!: DialogFullscreen

  @Ref()
  readonly input!: QInput

  get groupsOn () {
    return this.groups.filter(g => this.contact.contactGroups.includes(g.id.toString()))
  }

  get groupsOff () {
    return this.groups.filter(g => !this.contact.contactGroups.includes(g.id.toString()))
  }

  @Watch('name')
  change () {
    this.error = false
  }

  edit (contact: Contact) {
    this.contact = contact
    this.error = false
    this.name = this.contact.name
    this.dialog.show()
  }

  reset () {
    this.error = false
    this.name = this.contact.name
  }

  async saveName () {
    if (this.name.length && this.name !== this.contact.name) {
      this.loading = true
      const contact = await this.save({
        name: this.name
      })
      this.loading = false
      if (contact) {
        this.contact.name = contact.name
      } else {
        this.error = true
        this.$nextTick(() => { this.input.focus() })
      }
    }
  }

  async addGroup (group: ContactGroup) {
    const contact = await this.save({
      contactGroups: [...this.contact.contactGroups as string[], group.id.toString()]
    })
    if (contact) {
      this.contact.contactGroups = contact.contactGroups
    }
  }

  async delGroup (group: ContactGroup) {
    const contact = await this.save({
      contactGroups: this.contact.contactGroups.filter((id: string) => id !== group.id.toString())
    })
    if (contact) {
      this.contact.contactGroups = contact.contactGroups
    }
  }

  async save (data: ContactPatch) {
    const { data: { updateContact } } = await api.mutate({
      query: ContactUpdate,
      variables: {
        id: this.contact.id,
        data
      }
    })
    return updateContact?.contact
  }
}
